import React from 'react';
import { Link } from 'react-router-dom';
import { Thumbnail } from '/src/components';
import * as styles from './styles.scss';

const Category = ({ name, image, url_key }) => {
    const CategoryWrapper = url_key ? Link : 'div';

    return (
        <CategoryWrapper
            className={styles.category}
            { ...(url_key ? { to: `/${url_key}` } : {}) }
        >
            <Thumbnail.Category>
                {image && <img src={`${image}?d=355x260`} alt="" />}
            </Thumbnail.Category>
            <div className={styles.name}>
                <span>{name}</span>
            </div>
        </CategoryWrapper>
    )
};

export { default as categoryGraphQLQueries } from './graph-ql-queries';

export default Category;
